export default __webpack_public_path__ + "e69d7a30260cd881f62ce45276cdb6bd.png";